import { render, staticRenderFns } from "./schedules.page.vue?vue&type=template&id=dc845460&scoped=true&"
import script from "./schedules.page.vue?vue&type=script&lang=js&"
export * from "./schedules.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc845460",
  null
  
)

export default component.exports